import React from 'react';

export default function TitleButton({
  active = false,
  onClick,
  variant = 'button',
  value = '',
  titleItems = [],
  onChange,
  onSubmit,
  disabled = false,
  loading = false,
  activeTitle = '',
  onTitleSelect,
  onClearSelection,
  onActiveTitleOpen,
  onTitleDelete,
  canDeleteTitles = false,
  deletingTitle = '',
  submitLabel = 'Open Questions'
}) {
  const blockedTitles = new Set(['General Business']);
  const visibleTitleItems = titleItems.filter(({ title }) => {
    const normalized = typeof title === 'string' ? title.trim() : '';
    return normalized && !blockedTitles.has(normalized);
  });

  if (variant === 'list') {
    return (
      <div className="card">
        {loading ? (
          <div className="spinner-wrap"><div className="spinner"></div></div>
        ) : visibleTitleItems.length === 0 ? (
          <div className="empty-state" style={{ padding: '2rem 1rem' }}>
            <h3>No custom business titles yet</h3>
            <p>Add or seed custom titles, then return here to open question lists.</p>
          </div>
        ) : (
          <div style={{ display: 'grid', gap: '0.75rem' }}>
            {visibleTitleItems.map(({ title, count }) => (
              <div key={title} style={{ display: 'flex', gap: '0.75rem', alignItems: 'stretch' }}>
                <button
                  type="button"
                  onClick={() => onTitleSelect?.(title)}
                  className={`sidebar-item${activeTitle === title ? ' active' : ''}`}
                  style={{ flex: 1 }}
                >
                  <span>{title}</span>
                </button>
                {canDeleteTitles && (
                  <button
                    type="button"
                    className="btn btn-danger btn-sm"
                    onClick={() => onTitleDelete?.(title)}
                    disabled={deletingTitle === title}
                  >
                    {deletingTitle === title ? 'Deleting Title...' : 'Delete Title'}
                  </button>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    );
  }

  if (variant === 'form') {
    return (
      <div style={{ display: 'grid', gap: '0.85rem' }}>
        <form onSubmit={onSubmit} className="card" style={{ padding: '1rem 1.1rem' }}>
          <div style={{ display: 'grid', gap: '0.85rem' }}>
            <div>
              <label className="form-label" htmlFor="business-title-input">Business Title:</label>
              <input
                id="business-title-input"
                className="form-control"
                type="text"
                value={value}
                onChange={onChange}
                placeholder="Name your business title"
              />
              <p style={{ margin: '0.6rem 0 0', color: 'var(--color-text-light)', fontSize: '0.92rem' }}>
                Type the title the client chose.
              </p>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', gap: '0.75rem', alignItems: 'center', flexWrap: 'wrap' }}>
              <button type="submit" className="btn btn-primary" disabled={disabled}>
                {submitLabel}
              </button>
            </div>
          </div>
        </form>

        {activeTitle && (
          <div className="card" style={{ padding: '1rem 1.1rem' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', gap: '0.75rem', alignItems: 'center', flexWrap: 'wrap' }}>
              <div>
                <h3 className="card-title" style={{ marginBottom: '0.25rem' }}>Selected Title</h3>
                <p style={{ margin: 0, color: 'var(--color-text-light)' }}>{activeTitle}</p>
              </div>
              <div style={{ display: 'flex', gap: '0.6rem', alignItems: 'center', flexWrap: 'wrap' }}>
                <button type="button" className="btn btn-primary btn-sm" onClick={() => onActiveTitleOpen?.(activeTitle)}>
                  Open Questions
                </button>
                <button type="button" className="btn btn-secondary btn-sm" onClick={onClearSelection}>
                  Clear Selection
                </button>
              </div>
            </div>
          </div>
        )}

        <div className="card">
          {loading ? (
            <div className="spinner-wrap"><div className="spinner"></div></div>
          ) : visibleTitleItems.length === 0 ? (
            <div className="empty-state" style={{ padding: '2rem 1rem' }}>
              <h3>No custom business titles yet</h3>
              <p>Add or seed custom titles, then return here to open question lists.</p>
            </div>
          ) : (
            <div style={{ display: 'grid', gap: '0.75rem' }}>
              {visibleTitleItems.map(({ title, count }) => (
                <div key={title} style={{ display: 'flex', gap: '0.75rem', alignItems: 'stretch' }}>
                  <button
                    type="button"
                    onClick={() => onTitleSelect?.(title)}
                    className={`sidebar-item${activeTitle === title ? ' active' : ''}`}
                    style={{ flex: 1 }}
                  >
                    <span>{title}</span>
                    <span style={{ color: 'var(--color-text-light)', fontSize: '0.85rem', marginLeft: '0.75rem' }}>{count}</span>
                  </button>
                  {canDeleteTitles && (
                    <button
                      type="button"
                      className="btn btn-danger btn-sm"
                      onClick={() => onTitleDelete?.(title)}
                      disabled={deletingTitle === title}
                    >
                      {deletingTitle === title ? 'Deleting Title...' : 'Delete Title'}
                    </button>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    );
  }

  return (
    <button
      className={`tab-btn${active ? ' active' : ''}`}
      onClick={onClick}
      type="button"
    >
      Business Title:
    </button>
  );
}
